(() => {
  'use strict';
  const source = document.getElementById('neb-browse-strings');
  if (!source) return;
  const strings = JSON.parse(source.textContent);
  const paint = (root,key,name) => {
    const label = strings[key].replaceAll('__NAME__',name || '');
    root.querySelectorAll('[data-neb-browse-label]').forEach(node => { node.textContent = label; });
    root.querySelector('#ct-catalog-sidebar')?.setAttribute('aria-label',label);
  };
  const update = root => {
    const virtual = root.matches?.('[data-ct-virtual]') ? root : root.querySelector?.('[data-ct-virtual]');
    if (virtual?.dataset.nodeType) {
      const handle = virtual.dataset.handle;
      const type = virtual.dataset.nodeType;
      const title = virtual.querySelector('[data-ct-virtual-title] h1')?.textContent || '';
      let key = type === 'team' ? 'players' : type === 'player' ? 'teams' : 'context';
      let name = title;
      const parent = virtual.querySelector('.ct-context-parent');
      if (type === 'player' && parent?.getAttribute('href')?.includes('/ct-team-')) { key = 'players';name = parent.textContent; }
      else if (handle === 'ct-european-football') key = 'countries';
      else if (handle === 'ct-national-teams') key = 'regions';
      else if (/^ct-(nfl|mlb|nba|nhl|mls)$/.test(handle)) { key = 'team';name = handle.slice(3).toUpperCase(); }
      else if (/^ct-(football-|national-)/.test(handle)) key = 'team';
      else if (/^ct-(american-football|baseball|basketball|ice-hockey|soccer)$/.test(handle)) key = 'leagues';
      else if (handle === 'ct-all-jerseys') key = 'all';
      paint(virtual,key,name);
      return;
    }
    const related = root.matches?.('[data-ct-directory]') ? root : root.querySelector?.('[data-ct-directory][data-kind="related"]');
    if (related?.dataset.handle?.startsWith('ct-player-')) {
      const sidebar = related.closest('.ct-sidebar');
      const parent = sidebar?.querySelector('.ct-context-parent');
      if (parent?.getAttribute('href')?.includes('/ct-team-')) paint(sidebar.closest('.ct-catalog'),'players',parent.textContent);
    }
  };
  update(document);
  document.addEventListener('ct:catalog-ready',event => update(event.target));
  document.addEventListener('shopify:section:load',event => update(event.target));
})();
